import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ filter, sort, size, page }) =>
    present(
      repository
        .getOptimizedGantt(filter, sort, size, page)
        .then((gantt) => ({ gantt, sort, filter, size, page }))
        .catch(() => Promise.reject({ sort, filter, size, page })),
    );
}

export type { Interactor };

export { createInteractor };
